import { createAction } from 'redux-actions'
import { NAVBAR_HIDE_SPINNER, NAVBAR_SHOW_SPINNER, NAVBAR_SHOW_SLOW_SPINNER } from 'shared/constants/NavbarSpinner'

export const showNavbarSpinnerAction = createAction(NAVBAR_SHOW_SPINNER)
export const hideNavbarSpinnerAction = createAction(NAVBAR_HIDE_SPINNER)
export const showSlowNavbarSpinnerAction = createAction(NAVBAR_SHOW_SLOW_SPINNER)
